<template>
  <div id="modal" class="modal" v-show="modalShown">
    <div v-bind:class="{'modal-main': true, layoutType}">
      <div :class="'title-area ' + titleAreaAddStyle" v-if="title">
        <h2>{{ title }}</h2>
      </div>
      <div :class="'message-area ' + messageAreaAddStyle">
        <div v-html="m != null ? m.replace(/\n/g,'<br/>') : ''" v-for="(m, index) in messages" :key="index">
          {{ m }}
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onOkLoc">{{okBtnLabel}}</button>
        <button type="button" class="main_btn" @click="onCancelLoc" v-if="modalType !== 'message'">{{cancelBtnLabel}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {KEY_CODE} from '../../constants/App'
export default {
  name: 'Modal',
  props: {
    /** タイトル */
    title: {
      type: String,
      default: ''
    },
    /** メッセージ */
    messages: {
      type: Array,
      default: function () { return [] }
    },
    /** メッセージ表示 or 確認ダイアログ */
    modalType: {
      type: String,
      default: 'message' // or 'confirm'
    },
    /** 通常メッセージ or 成功メッセージ or エラーメッセージ */
    messageType: {
      type: String,
      default: 'info' // or 'success' or 'error'
    },
    /** ダイアログの見た目 default or classic */
    layoutType: {
      type: String,
      default: 'layout-default'
    },
    /** 中央寄り or 左寄り */
    textAlign: {
      type: String,
      default: 'center' // or 'left'
    },
    okBtnLabel: {
      type: String,
      default: 'OK'
    },
    cancelBtnLabel: {
      type: String,
      default: 'キャンセル'
    },
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    /** キャンセル押下時コールバック */
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    }
  },
  computed: {
    titleAreaAddStyle: function () {
      return this.messageType === 'error' ? ' error' : ''
    },
    messageAreaAddStyle: function () {
      return this.textAlign
    }
  },
  data () {
    return {
      modalShown: false
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onOkLoc: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    /** キャンセルボタン押下時 */
    onCancelLoc: function (event) {
      event.preventDefault()
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    /** enter|escキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        this.onOkLoc(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancelLoc(event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#modal {
  z-index: 10000;
}
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.error {
  color: #dc3545;
}
.message-area {
  font-weight: bold;
  line-height: 1.5;
}
.button-area {
  border-top: none;
}
.modal {
  .modal-main {
    .button-area {
      border-top: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/Modal.vue